/**
 * Date-extensions locale Pseudo [x-pseudo]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('x-pseudo', {
    monthNames: ['J~áñúá~rý','F~ébrú~árý','~Márc~h','Áp~ríl','~Máý','~Júñé~','Júl~ý','Áú~gúst~','Sép~témb~ér','Ó~ctób~ér','Ñ~óvém~bér','~Décé~mbér'],
    monthShortNames: ['J~áñ','~Féb','~Már','~Ápr','~Máý','~Júñ','~Júl','~Áúg','~Sép','~Óct','~Ñóv','~Déc'],
    dayNames: ['S~úñdá~ý','Mó~ñdáý~','Túé~sdáý~','Wéd~ñésd~áý','T~húrs~dáý','~Fríd~áý','S~átúr~dáý'],
    dayShortNames: ['S~úñ','~Móñ','~Túé','~Wéd','~Thú','~Frí','~Sát']
});
